import React, { useContext, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import SideNav, { NavItem, NavIcon, NavText } from "@trendmicro/react-sidenav";
import "@trendmicro/react-sidenav/dist/react-sidenav.css";
import { UserDataContext } from "../../UserContext";
import { UserDetailsContext } from "../../UserDetailsContext";
import { SidebarContext } from "../../SidebarContext";
import {
  Activity,
  Logmeout,
  currentRequestTimeStamp,
  getProcurementID,
} from "../Constants";
import Loader from "../Loader";
import RouterOutlet from "../../Routes";
import ModalBox from "../ModalBox";
import classes from "./wizard.module.css";
import mixpanel from "mixpanel-browser";
import { closeModal } from "../Utility";
import GavelIcon from "../Shared/Icons/GavelIcon";

const Wizard = () => {
  const [userData] = useContext(UserDataContext);
  const [userDetails] = useContext(UserDetailsContext);
  const {
    activeSection,
    expandedSections,
    setExpandedSections,
    setActiveSection,
  } = useContext(SidebarContext);

  const history = useHistory();
  const location = useLocation();

  const isProcurementAllowed = userData?.policy?.procurement?.allowed
    ? userData?.policy?.procurement?.allowed === "yes"
    : true;
  const isAuctionAllowed = userData?.policy?.auction?.allowed
    ? userData?.policy?.auction?.allowed === "yes"
    : true;

  // useEffect(() => {
  //   console.log(activeSection, "active section");
  //   console.log(expandedSections, "expanded section");
  // }, [activeSection, expandedSections]);

  useEffect(() => {
    if (location.pathname === "/login") {
      history.push("/");
    }
  }, [location, history]);

  useEffect(() => {
    if (Object.keys(userDetails).length > 0) {
      const { user_details } = userDetails;
      const { oid, user_id, name, emails, email } = user_details || {};
      const userEmail = (emails && emails[0]) || email || "";

      mixpanel.register({
        user_id: oid || user_id,
        user_name: name || userDetails.display_name || "",
        user_email: userEmail,
        time: currentRequestTimeStamp(),
        clientIP: sessionStorage.getItem("ClientIP"),
      });
    }
  }, [userDetails]);

  const handleSectionToggle = (section) => {
    setExpandedSections((prev) => ({ ...prev, [section]: !prev?.[section] }));
    if (section === "procurement") {
      setActiveSection("/");
      history.push("/");
    } else if (section === "auction") {
      setActiveSection("/auction");
      history.push("/auction");
    }
  };

  const renderNavItems = (items) => {
    return items.map((item) => (
      <NavItem
        key={item.eventKey}
        eventKey={item.eventKey}
        onClick={() => {
          if (item.onClick) {
            item.onClick();
          }
          history.push(item.eventKey);
        }}
        active={item.eventKey === activeSection}
      >
        <NavIcon>
          <i className={`${classes["s-icon"]} ${item.icon}`} />
        </NavIcon>
        <NavText>{item.text}</NavText>
      </NavItem>
    ));
  };

  const procurementItems = [
    {
      eventKey: "/",
      icon: "fa fa-fw fa-user-plus",
      text: "Create Procurements",
      id: "procurement_click",
    },
    {
      eventKey: `/lanes/${getProcurementID()}`,
      icon: "fa fa-road",
      text: "Add Lanes",
      id: "lanes_click",
    },
    {
      eventKey: `/shortlist/${getProcurementID()}`,
      icon: "fa fa-fw fa-list-alt",
      text: "Shortlist LSPs",
      id: "shortlist_click",
    },
    {
      eventKey: `/notifications/${getProcurementID()}`,
      icon: "fa fa-fw fa-bell-o",
      text: "Add Notifications",
      id: "notifications_click",
    },
    {
      eventKey: `/schedule/${getProcurementID()}`,
      icon: "fa fa-fw fa-calendar-check-o",
      text: "Publish Schedule",
      id: "schedule_click",
    },
    {
      eventKey: `/documents/${getProcurementID()}`,
      icon: "fa fa-fw fa-file-text-o",
      text: "Upload RFQ Documents",
      id: "documents_click",
    },
    {
      eventKey: `/uploads/${getProcurementID()}`,
      icon: "fa fa-fw fa-cloud-upload",
      text: "Request Documents",
      id: "uploads_click",
    },
    {
      eventKey: `/lsps/${getProcurementID()}`,
      icon: "fa fa-fw fa-truck",
      text: "LSP Ratecards",
      id: "lsp_click",
    },
    // {
    //   eventKey: `/uploadsbylsp/${getProcurementID()}`,
    //   icon: "fa fa-fw fa-folder-open-o",
    //   text: "Uploads by LSPs",
    //   id: "lspuploads_click",
    // },
    // {
    //   eventKey: `/rate-cards/${getProcurementID()}`,
    //   icon: "fa fa-fw fa-rupee",
    //   text: "Rate Cards",
    //   id: "rateCards_click",
    // },
    {
      eventKey: `/analyzeNow/${getProcurementID()}`,
      icon: "fa fa-fw fa-line-chart",
      text: "AnalyzeNow",
      id: "analysis_click",
    },
  ];

  const auctionItems = [
    { eventKey: "/auction", icon: "fa fa-fw fa-gavel", text: "Auctions" },
    {
      eventKey: "/lane_auction",
      icon: "fa fa-fw fa-gavel",
      text: "Advance Auctions",
    },
  ];

  const MobileSidebar = () => {
    const history = useHistory();

    const NavLink = ({ text, eventKey, icon, id }) => {
      const isActive = eventKey === activeSection;

      return (
        <div className="mb-3">
          <button
            onClick={() => {
              setActiveSection(eventKey);
              history.push(eventKey);
              closeModal();
            }}
            id={id}
            className={`btn btn-block d-flex align-items-center ${
              isActive ? "btn-primary" : "btn-outline-primary"
            }`}
            style={{
              fontWeight: isActive ? "bold" : "normal",
              backgroundColor: isActive ? "#007bff" : "",
              color: isActive ? "#fff" : "",
            }}
          >
            <span className="mx-2">
              <i className={icon} />
            </span>
            <span>{text}</span>
          </button>
        </div>
      );
    };

    return (
      <div className="p-3 bg-light">
        {/* procurement items */}
        <div className="mb-2 text-muted font-weight-bold">Procurement</div>
        {procurementItems.map(({ eventKey, icon, text, id }) => (
          <NavLink
            key={id}
            text={text}
            eventKey={eventKey}
            icon={icon}
            id={id}
          />
        ))}

        {/* auction items */}
        <div className="mb-2 text-muted font-weight-bold">Auctions</div>
        {auctionItems.map(({ eventKey, icon, text }) => (
          <NavLink key={eventKey} text={text} eventKey={eventKey} icon={icon} />
        ))}

        {/* Logout Button */}
        <div className="mt-4">
          <button
            onClick={Logmeout}
            className="btn btn-danger btn-block d-flex align-items-center"
          >
            <span className="me-2">
              <i className="fa fa-fw fa-power-off" />
            </span>
            <span>Logout</span>
          </button>
        </div>
      </div>
    );
  };

  const renderSideNav = () => (
    <SideNav
      className={classes["side-nav-color"]}
      expanded={expandedSections.main}
      onToggle={() => handleSectionToggle("main")}
      onSelect={(selected) => {
        if (selected === "Logout") {
          Logmeout();
        } else {
          history.push(selected);
        }
      }}
    >
      <SideNav.Toggle id="expand-close-sidenav" />
      <SideNav.Nav defaultSelected={location.pathname.split("/")[1]}>
        {isProcurementAllowed && (
          <>
            <NavItem
              className={`${classes["s-header"]}`}
              onClick={() => handleSectionToggle("procurement")}
            >
              <NavText>
                <span className="d-flex justify-content-between pr-4">
                  <span
                    style={{ color: "black", fontSize: "16px" }}
                    className="font-weight-bold"
                  >
                    Procurements
                  </span>
                  <span style={{ fontSize: "140%" }}>
                    <i
                      className={`fa ${
                        expandedSections.procurement
                          ? "fa-arrow-circle-down"
                          : "fa-arrow-circle-right"
                      }`}
                      style={{ color: "#000" }}
                    />
                  </span>
                </span>
              </NavText>
              {!expandedSections.main && (
                <NavIcon>
                  <span style={{ fontSize: "150%" }} className="mr-4">
                    <i
                      class="fa fa-shopping-cart"
                      style={{ color: "black" }}
                      aria-hidden="true"
                    ></i>
                  </span>
                </NavIcon>
              )}
            </NavItem>
            {expandedSections.procurement && renderNavItems(procurementItems)}
          </>
        )}
        {isAuctionAllowed && (
          <>
            <NavItem
              className={`${classes["s-header"]}`}
              onClick={() => handleSectionToggle("auction")}
            >
              <NavText>
                <span className="d-flex justify-content-between pr-4">
                  <span
                    style={{ color: "black", fontSize: "16px" }}
                    className="font-weight-bold"
                  >
                    Auctions
                  </span>
                  <span style={{ fontSize: "140%" }}>
                    <i
                      className={`fa ${
                        expandedSections.auction
                          ? "fa-arrow-circle-down"
                          : "fa-arrow-circle-right"
                      }`}
                      style={{ color: "#000" }}
                    />
                  </span>
                </span>
              </NavText>
              {!expandedSections.main && (
                <NavIcon>
                  <span style={{ fontSize: "150%" }} className="mr-4">
                    <GavelIcon size={30} color="black" />
                  </span>
                </NavIcon>
              )}
            </NavItem>
            {expandedSections.auction && renderNavItems(auctionItems)}
          </>
        )}
        <NavItem
          onClick={() =>
            Activity([
              {
                screen: "Side Panel",
                module: "Side Panel",
                user_activity: "Logout button clicked",
                timestamp: currentRequestTimeStamp(),
              },
            ])
          }
          eventKey="Logout"
        >
          <NavIcon>
            <i className={`${classes["s-icon"]} fa fa-sign-out`} />
          </NavIcon>
          <NavText>Back to LoRRI</NavText>
        </NavItem>
      </SideNav.Nav>
    </SideNav>
  );

  return (
    <div className={classes["Container"]}>
      <Loader show={!userData} />
      <div>
        {window.innerWidth > 600 ? (
          renderSideNav()
        ) : (
          <ModalBox
            buttonLabel={<i className="fa fa-bars" />}
            content={<MobileSidebar />}
            buttonID="wizardNavigation"
            buttonClass={classes["wizardMenu"]}
          />
        )}
      </div>
      <div className={classes["Body"]}>
        <RouterOutlet
          onlyAuction={isAuctionAllowed && !isProcurementAllowed}
          onlyProcurement={isProcurementAllowed && !isAuctionAllowed}
          both={isProcurementAllowed && isAuctionAllowed}
        />
      </div>
    </div>
  );
};

export default Wizard;
